// imports
import { FC } from 'react';

// components
import { AuthLayout } from 'components/common/AuthLayout';
import VerifyOTPComponent from 'components/VerifyOTP';

// constants
import { VERIFY_OTP_MESSAGE, VERIFY_OTP_TEXT } from 'constants/constant';

const VerifyOTP: FC = () => {
  return (
    <AuthLayout title={VERIFY_OTP_TEXT} subTitle={VERIFY_OTP_MESSAGE}>
      <VerifyOTPComponent />
    </AuthLayout>
  );
};

export default VerifyOTP;
